// Resources
import React from "react";
import Immutable from "immutable";
import { Link } from "react-router-dom";
// Styles
import { EditorWrapperEl } from "./styles/EditorWrapper";
import "@draft-js-plugins/inline-toolbar/lib/plugin.css";
import createMentionPlugin from "@draft-js-plugins/mention";
import "@draft-js-plugins/mention/lib/plugin.css";
import "@draft-js-plugins/text-alignment/lib/plugin.css";
import "prismjs/themes/prism.css"; // add prism.css to add highlights
// Components
import Prism from "prismjs";
import createPrismPlugin from "draft-js-prism-plugin";
import Editor from "@draft-js-plugins/editor";
import CodeUtils from "draft-js-code";
import {
	ContentState,
	EditorState,
	EditorBlock,
	RichUtils,
	getDefaultKeyBinding,
	convertFromRaw,
	convertToRaw,
	AtomicBlockUtils
} from "draft-js";
import "draft-js/dist/Draft.css";
import AddImagesWrapper from "../forms/AddImagesWrapper";
import createCounterPlugin from "@draft-js-plugins/counter";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import createInlineToolbarPlugin from "@draft-js-plugins/inline-toolbar";
import createImagePlugin from "@draft-js-plugins/image";
import createVideoPlugin from "@draft-js-plugins/video";
import createLinkPlugin from "@draft-js-plugins/anchor";

import {
	ItalicButton,
	BoldButton,
	UnderlineButton,
	CodeButton,
	HeadlineOneButton,
	HeadlineTwoButton,
	HeadlineThreeButton,
	UnorderedListButton,
	OrderedListButton,
	BlockquoteButton,
	CodeBlockButton
} from "@draft-js-plugins/buttons";
import createToolbarPlugin from "@draft-js-plugins/static-toolbar";
import createTextAlignmentPlugin from "@draft-js-plugins/text-alignment";
const prismPlugin = createPrismPlugin({
	// It's required to provide your own instance of Prism
	prism: Prism
});
const textAlignmentPlugin = createTextAlignmentPlugin();
const toolbarPlugin = createToolbarPlugin();
const imagePlugin = createImagePlugin();
const videoPlugin = createVideoPlugin();
const { types } = videoPlugin;
const linkPlugin = createLinkPlugin();
const counterPlugin = createCounterPlugin();
const linkifyPlugin = createLinkifyPlugin({
	target: "_blank",
	rel: "noreferrer"
});
const inlineToolbarPlugin = createInlineToolbarPlugin({
	structure: [BoldButton, ItalicButton, UnderlineButton, CodeButton, linkPlugin.LinkButton]
});
const mentionPlugin = createMentionPlugin({
	mentionTrigger: "@",
	mentionComponent: (mentionProps) => {
		return (
			<Link className="button" to={mentionProps.mention.link}>
				{mentionProps.children}
				<span style={{ paddingLeft: "0.5em" }}>&rsaquo;</span>
			</Link>
		);
	}
});
const { MentionSuggestions } = mentionPlugin;
const { InlineToolbar } = inlineToolbarPlugin;
const { CharCounter, WordCounter, LineCounter } = counterPlugin;
const { Toolbar } = toolbarPlugin;
const plugins = [
	mentionPlugin,
	textAlignmentPlugin,
	linkifyPlugin,
	toolbarPlugin,
	inlineToolbarPlugin,
	linkPlugin,
	// imagePlugin, removing overwrites imageblock
	videoPlugin,
	counterPlugin,
	prismPlugin
];
const test_json = (obj) => {
	try {
		let a = JSON.parse(obj); // eslint-disable-line
		return true;
	} catch (e) {
		return false;
	}
};
const toSlug = (str) =>
	str
		.toLowerCase()
		.trim()
		.replace(/\s+/g, "_")
		.replace(/[^a-z0-9_]/gi, "");
class HeadingBlock extends React.Component {
	render() {
		const text = this.props.contentState.getBlockForKey(this.props.block.key).getText();
		return (
			<div id={"goto_" + toSlug(text)} style={{ paddingTop: "2em" }}>
				<EditorBlock {...this.props} />
			</div>
		);
	}
}
class IframeEmbed extends React.Component {
	render() {
		const contentState = this.props.contentState;
		const entity = contentState.getEntity(this.props.block.getEntityAt(0));
		let { src } = entity.getData();
		if (src.match(/.(png|jpg|jpeg|svg|gif)/)) {
			return (
				<div>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
					<img
						src={src}
						alt={src}
						style={{
							maxWidth: "100%",
							maxHeight: "40.25vw"
						}}
					/>
				</div>
			);
		} else if (src.indexOf("youtube.com") !== -1 || src.indexOf("youtube-nocookie.com") !== -1) {
			let v = new URLSearchParams(src.substring(src.indexOf("?"))).get("v");
			let iframeUrl = "";
			if (v && src.indexOf("embed") === -1) {
				iframeUrl = "https://www.youtube-nocookie.com/embed/" + v + "?si=0S98-n_1quVyOF88";
			}
			return (
				<div>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
					<iframe
						width="560"
						height="315"
						src={iframeUrl || src}
						title={src}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
						allowFullScreen
						style={{
							maxWidth: "100%",
							maxHeight: "40.25vw"
						}}
					></iframe>
				</div>
			);
		} else if (src.match(/.(pdf)/)) {
			return (
				<div>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
					<iframe
						src={src + "#toolbar=0&view=Fit"}
						style={{ width: "100%", height: "80vh" }}
						title={src}
					></iframe>
				</div>
			);
		} else if (src.indexOf("docs.google.com/") !== -1 || src.indexOf("calendar.google.com/calendar/embed") !== -1) {
			return (
				<div>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
					<iframe src={src} style={{ width: "100%", height: "80vh" }} title={src}></iframe>
				</div>
			);
		} else if (src.match(/.(doc|docx|ppt|pptx|xls|xlsx)/)) {
			return (
				<div>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
					<iframe
						src={"https://view.officeapps.live.com/op/embed.aspx?src=" + src}
						style={{ width: "100%", height: "80vh" }}
						title={src}
					></iframe>
				</div>
			);
		}
		return (
			<div>
				<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
					{src}
				</a>
				<iframe src={src} style={{ width: "100%", height: "80vh" }} title={src}></iframe>
			</div>
		);
	}
}
class IframePreview extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showIframe: false
		};
	}
	onMouseEnter = () => {
		this.setState({ showIframe: true });
	};
	onMouseLeave = () => {
		this.setState({ showIframe: false });
	};
	pdfIcon = () => (
		<svg width="20px" height="20px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.5 8H3V7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8Z" fill="currentColor" />
			<path d="M7 10V7H7.5C7.77614 7 8 7.22386 8 7.5V9.5C8 9.77614 7.77614 10 7.5 10H7Z" fill="currentColor" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 1.5C1 0.671573 1.67157 0 2.5 0H10.7071L14 3.29289V13.5C14 14.3284 13.3284 15 12.5 15H2.5C1.67157 15 1 14.3284 1 13.5V1.5ZM3.5 6H2V11H3V9H3.5C4.32843 9 5 8.32843 5 7.5C5 6.67157 4.32843 6 3.5 6ZM7.5 6H6V11H7.5C8.32843 11 9 10.3284 9 9.5V7.5C9 6.67157 8.32843 6 7.5 6ZM10 11V6H13V7H11V8H12V9H11V11H10Z"
				fill="currentColor"
			/>
		</svg>
	);
	googleIcon = () => (
		<svg
			fill="currentColor"
			height="20px"
			width="20px"
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 210 210"
		>
			<path
				d="M0,105C0,47.103,47.103,0,105,0c23.383,0,45.515,7.523,64.004,21.756l-24.4,31.696C133.172,44.652,119.477,40,105,40
	c-35.841,0-65,29.159-65,65s29.159,65,65,65c28.867,0,53.398-18.913,61.852-45H105V85h105v20c0,57.897-47.103,105-105,105
	S0,162.897,0,105z"
			/>
		</svg>
	);
	officeIcon = () => (
		<svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="24" fill="none" />
			<path d="M3,18l4-1.25V7l7-2V19.5L3.5,18.25,14,22l6-1.25V3.5L14,2,3,5.75Z" />
		</svg>
	);
	render() {
		const contentState = this.props.contentState;
		const entity = contentState.getEntity(this.props.block.getEntityAt(0));
		let { src } = entity.getData();
		if (src.match(/.(png|jpg|jpeg|svg|gif)/)) {
			return (
				<div>
					<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
						Image Preview
						{this.state.showIframe && (
							<img
								src={src}
								alt={src}
								style={{
									maxWidth: "100%",
									maxHeight: "40.25vw",
									position: "absolute",
									zIndex: 99
								}}
							/>
						)}
					</button>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
				</div>
			);
		} else if (src.indexOf("youtube.com") !== -1 || src.indexOf("youtube-nocookie.com") !== -1) {
			let v = new URLSearchParams(src.substring(src.indexOf("?"))).get("v");
			let iframeUrl = "";
			if (v && src.indexOf("embed") === -1) {
				iframeUrl = "https://www.youtube-nocookie.com/embed/" + v + "?si=0S98-n_1quVyOF88";
			}
			return (
				<div>
					<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
						Video Preview
						{this.state.showIframe && (
							<iframe
								width="560"
								height="315"
								src={iframeUrl || src}
								title={src}
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
								allowFullScreen
								style={{
									maxWidth: "100%",
									maxHeight: "40.25vw",
									position: "absolute",
									zIndex: 99
								}}
							></iframe>
						)}
					</button>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
				</div>
			);
		} else if (src.indexOf(".pdf") !== -1) {
			return (
				<div>
					<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
						{this.pdfIcon()} Preview
						{this.state.showIframe && (
							<iframe
								src={src}
								style={{ width: "100%", height: "50vh", position: "absolute", zIndex: 99 }}
								title={src}
							></iframe>
						)}
					</button>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
				</div>
			);
		} else if (src.indexOf("docs.google.com") !== -1 || src.indexOf("calendar.google.com/calendar/embed") !== -1) {
			return (
				<div>
					<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
						{this.googleIcon()} Preview
						{this.state.showIframe && (
							<iframe
								src={src}
								style={{ width: "100%", height: "50vh", position: "absolute", zIndex: 99 }}
								title={src}
							></iframe>
						)}
					</button>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
				</div>
			);
		} else if (src.match(/.(doc|docx|ppt|pptx|xls|xlsx)/)) {
			return (
				<div>
					<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
						{this.officeIcon()} Preview
						{this.state.showIframe && (
							<iframe
								src={"https://view.officeapps.live.com/op/embed.aspx?src=" + src}
								style={{ width: "100%", height: "50vh", position: "absolute", zIndex: 99 }}
								title={src}
							></iframe>
						)}
					</button>
					<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
						{src}
					</a>
				</div>
			);
		}
		return (
			<div>
				<button className="btn btn-sm" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					Preview
					{this.state.showIframe && (
						<iframe
							src={src}
							style={{ width: "100%", height: "50vh", position: "absolute", zIndex: 99 }}
							title={src}
						></iframe>
					)}
				</button>
				<a style={{ fontSize: "0.8em" }} href={src} target="_blank" rel="noopener noreferrer">
					{src}
				</a>
			</div>
		);
	}
}
class ImageBlock extends React.Component {
	// For later when we want to add more features
	constructor(props) {
		super(props);
		const entity = props.contentState.getEntity(props.block.getEntityAt(0));
	}
	
	render() {
		const contentState = this.props.contentState;
		const entity = contentState.getEntity(this.props.block.getEntityAt(0));
		let { src, alt } = entity.getData();
		//TODO: Slight lag when changing, save for another day
		// const readOnly = this.props.blockProps.readOnly;

		return (
            <div className="image-block">
				{/* {!readOnly && (
                    <button className="image-remove">&#10005;</button>
                )} */}
                <img 
                    src={src}
                    alt={alt || ""}
                />
            </div>
        );
	}
}

const blockRenderMap = Immutable.Map({
	"header-one": {
		element: "h2"
	},
	"header-two": {
		element: "h3"
	},
	"header-three": {
		element: "h4"
	},
	"header-four": {
		element: "h5"
	},
	"header-five": {
		element: "h6"
	}
});
class EditorWrapper extends React.Component {
	constructor(props) {
		super(props);
		if (props.article.content) {
			this.state = {
				articles: [],
				articlesVisible: [],
				mentionOpen: false,
				highlightColor: "#feda5a",
				showAddImagePrompt : false,
				editorState:
					props.article.content.indexOf('{"blocks"') !== 0 || !test_json(props.article.content)
						? EditorState.createWithContent(ContentState.createFromText(props.article.content))
						: EditorState.createWithContent(convertFromRaw(JSON.parse(props.article.content)))
			};
		} else {
			this.state = { editorState: EditorState.createEmpty() };
		}
		this.toggleBlockType = this._toggleBlockType.bind(this);
		this.toggleInlineStyle = this._toggleInlineStyle.bind(this);

		this.onChange = (editorState) => {
			// this.updateCodeBlock(editorState);
			this.setState({ editorState });
			let storage = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
			if (this.props.reportDraftChange) this.props.reportDraftChange(storage);
		};
	}
	handleInputChange = (e) => {
		let opts = {};
		if (e && e.target) {
			opts[e.target.name] = e.target.value;
		}
		this.setState(opts);
	};
	updateCodeBlock = (editorState) => {
		const contentState = editorState.getCurrentContent();
		const selectionState = editorState.getSelection();
		const currentBlock = contentState.getBlockForKey(selectionState.getStartKey());
		const block = currentBlock;
		if (block.getType() !== "code-block") return;
		let language = "javascript";
		const data = block.getData().merge({ language: language });
		const newBlock = block.merge({ data });
		const newContentState = contentState.merge({
			blockMap: contentState.getBlockMap().set(block.getKey(), newBlock),
			selectionAfter: contentState.getSelectionBefore()
		});
		this.setState({
			editorState: EditorState.push(this.state.editorState, newContentState, "change-block-data")
		});
	};
	blockRenderer = (contentBlock) => {
		const type = contentBlock.getType();
		if (contentBlock.getEntityAt(0)) {
			const contentState = this.state.editorState.getCurrentContent();
			const entity = contentState.getEntity(contentBlock.getEntityAt(0));
			const entityType = entity.getType();
			if (entityType === "IframeEmbed") {
				return {
					component: IframeEmbed,
					editable: false
				};
			} else if (entityType === "IframePreview") {
				return {
					component: IframePreview,
					editable: false
				};
			} else if (entityType === "IMAGE") {
				return {
					component: ImageBlock,
					editable: false,
					props: {
            			readOnly: this.props.readOnly,
					}
				};
			}
		}
		if (type.startsWith("header")) {
			return {
				component: HeadingBlock,
				editable: !this.props.readOnly
			};
		}
		return null;
	};
	focus = () => this.editor.focus();
	_toggleBlockType(blockType) {
		this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
	}
	_toggleInlineStyle(inlineStyle) {
		this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
	}
	handleDefaultButtonClick = () => {
		const newEditorState = RichUtils.toggleBlockType(this.state.editorState, "unstyled");
		if (newEditorState !== this.state.editorState) {
			this.onChange(newEditorState);
		}
	};
	handleClick = () => {
		let input = prompt("Enter an image URL:");
		if (!input) {
			return;
		}
		let newEditorState;
		if (input.startsWith("data:image/")) {
			newEditorState = this.insertImage(input);
		} else {
			const entityData = { src: input };
			newEditorState = this.insertImageURL(entityData);
		}
		this.onChange(newEditorState);
	};
	handleAddImagePrompt = () => {
		this.setState({ 
			showAddImagePrompt: !this.state.showAddImagePrompt
		});
	};
	_handleMaskClick = () => {
		// console.log('[ Company - _handleMaskClick ] Mask clicked');
	};
	handleImageInsert = (url, alt) => {
		const entityData = { src : url, alt: alt || "" };
		const newEditorState = this.insertImageURL(entityData);
		this.onChange(newEditorState);
	};
	handleIframePreviewClick = () => {
		const input = prompt(
			"Enter a URL\nAccepts: doc, docx, ppt, pptx, xls, xlsx, pdf, png, jpg, jpeg, svg, gif\nGoogle Drive, Google Calendar, Youtube, or other iframeable URLs."
		);
		if (!input) {
			return;
		}
		const entityData = { src: input, url: input };
		const newEditorState = this.insertIframePreviewURL(input, entityData);
		this.onChange(newEditorState);
	};
	handleIframeEmbedClick = () => {
		const input = prompt(
			"Enter a URL\nAccepts: doc, docx, ppt, pptx, xls, xlsx, pdf, png, jpg, jpeg, svg, gif\nGoogle Drive, Google Calendar, Youtube, or other iframeable URLs."
		);
		if (!input) {
			return;
		}
		const entityData = { src: input, url: input };
		const newEditorState = this.insertIframeEmbedURL(input, entityData);
		this.onChange(newEditorState);
	};
	handleVideoClick = () => {
		const input = prompt("Enter a video URL:");
		if (!input) {
			return;
		}
		const entityData = { src: input };
		const newEditorState = this.insertVideoURL(entityData);
		this.onChange(newEditorState);
	};
	insertIframeEmbedURL = (title, entityData) => {
		const contentState = this.state.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity("IframeEmbed", "IMMUTABLE", entityData);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(this.state.editorState, {
			currentContent: contentStateWithEntity
		});
		return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
	};
	insertIframePreviewURL = (title, entityData) => {
		const contentState = this.state.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity("IframePreview", "IMMUTABLE", entityData);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(this.state.editorState, {
			currentContent: contentStateWithEntity
		});
		return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
	};
	insertVideoURL = (entityData) => {
		const contentState = this.state.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity(types.VIDEOTYPE, "IMMUTABLE", entityData);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(this.state.editorState, {
			currentContent: contentStateWithEntity
		});
		return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
	};
	insertImage = (base64) => {
		const contentState = this.state.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", { src: base64 });
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(this.state.editorState, {
			currentContent: contentStateWithEntity
		});
		return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
	};
	insertImageURL = (entityData) => {
		const contentState = this.state.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", entityData);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = EditorState.set(this.state.editorState, {
			currentContent: contentStateWithEntity
		});
		return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
	};
	handleFileChange = (event) => {
		const file = event.target.files[0];
		const maxFileSize = 0.5 * 1024 * 1024; // 0.5 MB
		if (file.size > maxFileSize)
			return alert(
				"Too large: " +
					(file.size / 1024 / 1024).toFixed(1) +
					"MB\nReduce the filesize below " +
					(maxFileSize / 1024 / 1024).toFixed(1) +
					"MB or use an Image URL instead."
			);
		if (file) {
			const reader = new FileReader();
			reader.onloadend = () => {
				const base64 = reader.result;
				const newEditorState = this.insertImage(base64);
				this.onChange(newEditorState);
			};
			reader.readAsDataURL(file);
		}
	};
	onSearchChange = ({ value }) => {
		this.setState({
			articlesVisible: this.props.articles.filter(function (article) {
				return article.title.match(new RegExp(value, "i"));
			})
		});
	};
	onOpenChange = (value) => {
		this.setState({
			articlesVisible: this.props.articles,
			mentionOpen: value
		});
	};
	highlightIcon = () => (
		<svg width="20px" height="20px" viewBox="0 0 512 512" version="1.1">
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="drop" fill="currentColor" transform="translate(64.000000, 44.956885)">
					<path
						d="M405.333333,381.709781 L362.666667,424.376448 L85.3333333,424.376448 L128,381.709781 L405.333333,381.709781 Z M41.168,299.372 L103.67,361.874 L42.6666667,392.376448 L1.42108547e-14,403.043115 L10.6666667,360.376448 L41.168,299.372 Z M61.1,191.304 L212.137,342.341 L206.971557,347.655494 L201.097332,347.365048 L194.94444,347.269241 C184.457401,347.271762 172.809254,348.085275 160,349.709781 L151.970104,350.837434 L144.123951,352.129117 L136.61735,353.518237 L127.387,355.421 L48.9491375,276.983016 C50.507182,270.709588 52.0860762,262.939495 53.3333333,253.709781 C55.8645145,234.979019 56.7941068,216.011107 56.1221103,196.806047 L59.4284876,193.08414 L61.1,191.304 Z M282.327442,7.10542736e-15 L403.006999,120.679557 L384.970948,143.928809 L352.415716,185.42913 L333.317316,209.393653 L316.302987,230.396289 L304.909911,244.204529 L291.542704,260.023864 L282.884971,269.944627 L275.399527,278.199329 L269.086373,284.787971 L254.094195,299.615469 L227.035,327.069 L75.976,176.01 L78.5389897,173.389008 L116.39305,135.764502 L128.060065,124.568671 L141.033549,112.687653 L152.352994,102.689504 L164.50858,92.2528346 L177.500305,81.3776459 L191.328171,70.0639374 L205.992177,58.3117091 L229.55595,39.8611422 L246.310307,27.0126145 L263.900804,13.7255671 L282.327442,7.10542736e-15 Z"
						id="Combined-Shape"
					></path>
				</g>
			</g>
		</svg>
	);
	embedIcon = () => (
		<svg fill="currentColor" version="1.1" id="Layer_1" viewBox="0 0 32 32">
			<g id="embed">
				<path
					id="embed_1_"
					d="M27,31.36H3c-1.301,0-2.36-1.059-2.36-2.36V5c0-1.301,1.059-2.36,2.36-2.36h13v0.72H3
		C2.096,3.36,1.36,4.096,1.36,5v24c0,0.904,0.736,1.64,1.64,1.64h24c0.904,0,1.64-0.735,1.64-1.64V16h0.721v13
		C29.36,30.302,28.302,31.36,27,31.36z M23,18.36h-9.36V9h0.72v8.131L30.745,0.746l0.51,0.509L14.869,17.64H23V18.36z"
				/>
			</g>
			<rect id="_Transparent_Rectangle" style={{ fill: "none" }} width="32" height="32" />
		</svg>
	);
	previewIcon = () => (
		<svg fill="currentColor" width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<path d="M16 2H7.979C6.88 2 6 2.88 6 3.98V12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10H8V4h8v8zM4 10H2v6c0 1.1.9 2 2 2h6v-2H4v-6z" />
		</svg>
	);
	videoIcon = () => (
		<svg width="20px" height="20px" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 10.4656V13.5344C8 15.6412 10.2299 16.4543 11.6609 15.7205L14.6534 14.1861C16.4489 13.2655 16.4488 10.7345 14.6534 9.81391L11.6609 8.27949C10.2299 7.54573 8 8.3588 8 10.4656ZM10 13.5344C10 13.8889 10.4126 14.113 10.7484 13.9408L13.7409 12.4064C14.0864 12.2293 14.0864 11.7707 13.7409 11.5936L10.7484 10.0592C10.4126 9.88702 10 10.1111 10 10.4656V13.5344Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H7ZM4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7Z"
			/>
		</svg>
	);
	uploadIcon = () => (
		<svg fill="currentColor" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path d="M19,13a1,1,0,0,0-1,1v.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.7L9.41,11.12a2.85,2.85,0,0,0-3.93,0L4,12.6V7A1,1,0,0,1,5,6h7a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13ZM5,20a1,1,0,0,1-1-1V15.43l2.9-2.9a.79.79,0,0,1,1.09,0l3.17,3.17,0,0L15.46,20Zm13-1a.89.89,0,0,1-.18.53L13.31,15l.7-.7a.77.77,0,0,1,1.1,0L18,17.21ZM22.71,4.29l-3-3a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L18,4.41V10a1,1,0,0,0,2,0V4.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,4.29Z" />
		</svg>
	);
	imageIcon = () => (
		<svg width="20px" height="20px" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.2639 15.9375L12.5958 14.2834C11.7909 13.4851 11.3884 13.086 10.9266 12.9401C10.5204 12.8118 10.0838 12.8165 9.68048 12.9536C9.22188 13.1095 8.82814 13.5172 8.04068 14.3326L4.04409 18.2801M14.2639 15.9375L14.6053 15.599C15.4112 14.7998 15.8141 14.4002 16.2765 14.2543C16.6831 14.126 17.12 14.1311 17.5236 14.2687C17.9824 14.4251 18.3761 14.8339 19.1634 15.6514L20 16.4934M14.2639 15.9375L18.275 19.9565M18.275 19.9565C17.9176 20 17.4543 20 16.8 20H7.2C6.07989 20 5.51984 20 5.09202 19.782C4.71569 19.5903 4.40973 19.2843 4.21799 18.908C4.12796 18.7313 4.07512 18.5321 4.04409 18.2801M18.275 19.9565C18.5293 19.9256 18.7301 19.8727 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V16.4934M4.04409 18.2801C4 17.9221 4 17.4575 4 16.8V7.2C4 6.0799 4 5.51984 4.21799 5.09202C4.40973 4.71569 4.71569 4.40973 5.09202 4.21799C5.51984 4 6.07989 4 7.2 4H16.8C17.9201 4 18.4802 4 18.908 4.21799C19.2843 4.40973 19.5903 4.71569 19.782 5.09202C20 5.51984 20 6.0799 20 7.2V16.4934M17 8.99989C17 10.1045 16.1046 10.9999 15 10.9999C13.8954 10.9999 13 10.1045 13 8.99989C13 7.89532 13.8954 6.99989 15 6.99989C16.1046 6.99989 17 7.89532 17 8.99989Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
	linkIcon = () => (
		<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22ZM9.198 7.25H9.30203C10.2005 7.24997 10.9497 7.24995 11.5445 7.32991C12.1723 7.41432 12.7391 7.59999 13.1945 8.05546C13.65 8.51093 13.8357 9.07773 13.9201 9.70552C14.0001 10.3003 14 11.0495 14 11.948L14 12C14 12.4142 13.6642 12.75 13.25 12.75C12.8358 12.75 12.5 12.4142 12.5 12C12.5 11.036 12.4984 10.3884 12.4335 9.9054C12.3714 9.44393 12.2642 9.24644 12.1339 9.11612C12.0036 8.9858 11.8061 8.87858 11.3446 8.81654C10.8616 8.7516 10.214 8.75 9.25 8.75C8.28599 8.75 7.63843 8.7516 7.15539 8.81654C6.69393 8.87858 6.49644 8.9858 6.36612 9.11612C6.2358 9.24644 6.12858 9.44393 6.06654 9.9054C6.0016 10.3884 6 11.036 6 12C6 12.964 6.0016 13.6116 6.06654 14.0946C6.12858 14.5561 6.2358 14.7536 6.36612 14.8839C6.49644 15.0142 6.69393 15.1214 7.15539 15.1835C7.63843 15.2484 8.28599 15.25 9.25 15.25C9.66422 15.25 10 15.5858 10 16C10 16.4142 9.66422 16.75 9.25 16.75L9.19798 16.75C8.29951 16.75 7.5503 16.7501 6.95552 16.6701C6.32773 16.5857 5.76093 16.4 5.30546 15.9445C4.84999 15.4891 4.66432 14.9223 4.57991 14.2945C4.49995 13.6997 4.49997 12.9505 4.5 12.052V11.948C4.49997 11.0495 4.49995 10.3003 4.57991 9.70552C4.66432 9.07773 4.84999 8.51093 5.30546 8.05546C5.76093 7.59999 6.32773 7.41432 6.95552 7.32991C7.55029 7.24995 8.29954 7.24997 9.198 7.25ZM16.8446 8.81654C16.3616 8.7516 15.714 8.75 14.75 8.75C14.3358 8.75 14 8.41422 14 8C14 7.58579 14.3358 7.25 14.75 7.25L14.802 7.25C15.7005 7.24997 16.4497 7.24995 17.0445 7.32991C17.6723 7.41432 18.2391 7.59999 18.6945 8.05546C19.15 8.51093 19.3357 9.07773 19.4201 9.70552C19.5001 10.3003 19.5 11.0495 19.5 11.9479V12.052C19.5 12.9505 19.5001 13.6997 19.4201 14.2945C19.3357 14.9223 19.15 15.4891 18.6945 15.9445C18.2391 16.4 17.6723 16.5857 17.0445 16.6701C16.4497 16.7501 15.7005 16.75 14.802 16.75H14.698C13.7995 16.75 13.0503 16.7501 12.4555 16.6701C11.8277 16.5857 11.2609 16.4 10.8055 15.9445C10.35 15.4891 10.1643 14.9223 10.0799 14.2945C9.99995 13.6997 9.99997 12.9505 10 12.052L10 12C10 11.5858 10.3358 11.25 10.75 11.25C11.1642 11.25 11.5 11.5858 11.5 12C11.5 12.964 11.5016 13.6116 11.5665 14.0946C11.6286 14.5561 11.7358 14.7536 11.8661 14.8839C11.9964 15.0142 12.1939 15.1214 12.6554 15.1835C13.1384 15.2484 13.786 15.25 14.75 15.25C15.714 15.25 16.3616 15.2484 16.8446 15.1835C17.3061 15.1214 17.5036 15.0142 17.6339 14.8839C17.7642 14.7536 17.8714 14.5561 17.9335 14.0946C17.9984 13.6116 18 12.964 18 12C18 11.036 17.9984 10.3884 17.9335 9.9054C17.8714 9.44393 17.7642 9.24644 17.6339 9.11612C17.5036 8.9858 17.3061 8.87858 16.8446 8.81654Z"
				fill="currentColor"
			/>
		</svg>
	);

	handleKeyCommand = (command) => {
		const { editorState } = this.state;
		let newState;
		if (CodeUtils.hasSelectionInBlock(editorState)) {
			newState = CodeUtils.handleKeyCommand(editorState, command);
		}
		if (!newState) {
			newState = RichUtils.handleKeyCommand(editorState, command);
		}
		if (newState) {
			this.onChange(newState);
			return "handled";
		}
		return "not-handled";
	};

	promptForLink = () => {
		const { editorState } = this.state;
		const selection = editorState.getSelection();
		if (!selection.isCollapsed()) {
			const contentState = editorState.getCurrentContent();
			const startKey = selection.getStartKey();
			const startOffset = selection.getStartOffset();
			const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
			const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
			let currentUrl = "";

			if (linkKey) {
				const linkInstance = contentState.getEntity(linkKey);
				currentUrl = linkInstance.getData().url;
			}

			const url = window.prompt("Enter a URL", currentUrl);
			if (url !== null) {
				// Check for null to handle cancel button in prompt
				this.confirmLink(url);
			}
		}
	};

	confirmLink = (url) => {
		const { editorState } = this.state;
		const contentState = editorState.getCurrentContent();
		let newEditorState;

		if (url) {
			const contentStateWithEntity = contentState.createEntity("LINK", "MUTABLE", { url });
			const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
			newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
			newEditorState = RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey);
		} else {
			newEditorState = RichUtils.toggleLink(editorState, editorState.getSelection(), null);
		}

		this.onChange(newEditorState);
	};

	keyBindingFn = (evt) => {
		const { editorState } = this.state;
		const command = CodeUtils.getKeyBinding(evt);
		if (evt.keyCode === 9 /* TAB */) {
			if (CodeUtils.hasSelectionInBlock(editorState)) {
				this.onChange(CodeUtils.onTab(evt, editorState));
			} else {
				const newEditorState = RichUtils.onTab(evt, this.state.editorState, 4);
				if (newEditorState !== this.state.editorState) {
					this.onChange(newEditorState);
				}
			}
			return;
		}

		return command || getDefaultKeyBinding(evt);
	};

	handleReturn = (evt) => {
		const { editorState } = this.state;
		if (!CodeUtils.hasSelectionInBlock(editorState)) return "not-handled";

		this.onChange(CodeUtils.handleReturn(evt, editorState));
		return "handled";
	};
	handleLinkClick = (event) => {
		let targetElement = event.target;
		// Traverse up the DOM tree until an <a> tag is found or until the body is reached
		while (targetElement && targetElement.tagName !== "A" && targetElement !== document.body) {
			targetElement = targetElement.parentNode;
		}
		if (targetElement && targetElement.tagName === "A") {
			if (!targetElement.href.includes(window.location.host)) {
				event.preventDefault();
				window.open(targetElement.href, "_blank");
			}
		}
	};
	componentWillUnmount() {
		document.removeEventListener("click", this.handleLinkClick);
	}
	componentDidMount() {
		document.addEventListener("click", this.handleLinkClick);
	}

	render() {
		const { editorState } = this.state;
		return (
			<EditorWrapperEl>
				{!this.props.readOnly && (
					<Toolbar>
						{(externalProps) => (
							<div className="menu-buttons">
								<div className="button-list">
									<button onClick={this.handleDefaultButtonClick} aria-label="Paragraph">
										&para;
									</button>
									<HeadlineOneButton {...externalProps} />
									<HeadlineTwoButton {...externalProps} />
									<HeadlineThreeButton {...externalProps} />
									<UnorderedListButton {...externalProps} />
									<OrderedListButton {...externalProps} />
									<BlockquoteButton {...externalProps} />
									<CodeBlockButton {...externalProps} />
									<button onClick={this.handleIframeEmbedClick}>
										{this.embedIcon()}
										<span style={{ fontSize: "0.5em" }}> Iframe</span>
									</button>
									<button onClick={this.handleIframePreviewClick}>
										{this.previewIcon()}
										<span style={{ fontSize: "0.5em" }}> Preview</span>
									</button>
									<button onClick={this.handleVideoClick}>
										{this.videoIcon()}
										<span style={{ fontSize: "0.5em" }}> Video</span>
									</button>
									<button onClick={this.handleClick}>
										{this.imageIcon()}
										<span style={{ fontSize: "0.5em" }}> URL</span>
									</button>
									<input
										type="file"
										id="fileInput"
										accept="image/*"
										onChange={this.handleFileChange}
										style={{ display: "none" }}
									/>
									{/* <label htmlFor="fileInput" className="button">
										{this.imageIcon()}
										<span style={{ fontSize: "0.5em" }}> Embed</span>
									</label> */}
									{/* <a
										href="https://www2.upsellit.com/admin/control/edit/manage_images.jsp?companyID=5462&type=4"
										target="_blank"
										rel="noreferrer"
										className="btn"
										title="Upload"
										style={{ marginTop: "5px" }}
									>
										{this.uploadIcon()}
									</a> */}
									<button onClick={this.handleAddImagePrompt}>
										{this.uploadIcon()}
										<span style={{ fontSize: "0.5em" }}></span>
									</button>
								</div>
							</div>
						)}
					</Toolbar>
				)}
				<div className="RichEditor-root">
					<div onClick={this.focus}>
						<Editor
							keyBindingFn={this.keyBindingFn}
							handleKeyCommand={this.handleKeyCommand}
							handleReturn={this.handleReturn}
							blockRenderMap={blockRenderMap}
							blockRendererFn={this.blockRenderer}
							editorState={editorState}
							onChange={this.onChange}
							placeholder={this.props.placeholder || "Tell a story..."}
							plugins={plugins}
							customStyleMap={{
								HIGHLIGHT_red: {
									backgroundColor: "var(--red)",
									// backgroundColor: this.state.highlightColor,
									color: "black",
									padding: "0.1em"
								},
								HIGHLIGHT_orange: {
									backgroundColor: "var(--orange)",
									color: "black",
									padding: "0.1em"
								},
								HIGHLIGHT_yellow: {
									backgroundColor: "var(--yellow)",
									color: "black",
									padding: "0.1em"
								},
								HIGHLIGHT_green: {
									backgroundColor: "var(--green)",
									color: "black",
									padding: "0.1em"
								},
								HIGHLIGHT_blue: {
									backgroundColor: "var(--lightblue)",
									color: "black",
									padding: "0.1em"
								},
								HIGHLIGHT_violet: {
									backgroundColor: "var(--lightviolet)",
									color: "black",
									padding: "0.1em"
								}
							}}
							ref={(element) => {
								this.editor = element;
							}}
							spellCheck={!this.props.readOnly}
							readOnly={this.props.readOnly}
						/>
						{!this.props.readOnly && (
							<div className="inline-toolbar">
								<InlineToolbar>
									{(externalProps) => (
										<div>
											<BoldButton {...externalProps} />
											<ItalicButton {...externalProps} />
											<UnderlineButton {...externalProps} />
											<button
												style={{ margin: 0, width: "2.5em", height: "2.5em", border: "none" }}
												className="btn btn-sm"
												onMouseDown={(e) => {
													e.preventDefault();
													const colorsDiv = document.querySelector(".highlight-colors");
													colorsDiv.style.display =
														colorsDiv.style.display === "none" ? "" : "none";
												}}
											>
												{this.highlightIcon()}
											</button>
											<div
												className="highlight-colors"
												style={{ display: "none", position: "absolute", top: "-3em" }}
											>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--red)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_red");
													}}
												>
													{" "}
												</button>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--orange)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_orange");
													}}
												>
													{" "}
												</button>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--yellow)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_yellow");
													}}
												>
													{" "}
												</button>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--green)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_green");
													}}
												>
													{" "}
												</button>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--lightblue)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_blue");
													}}
												>
													{" "}
												</button>
												<button
													style={{
														margin: 0,
														width: "2.75em",
														height: "2.75em",
														backgroundColor: "var(--lightviolet)"
													}}
													className="btn btn-sm"
													onMouseDown={(e) => {
														e.preventDefault();
														this._toggleInlineStyle("HIGHLIGHT_violet");
													}}
												>
													{" "}
												</button>
											</div>
											<CodeButton {...externalProps} />

											<button
												style={{ margin: 0, width: "2.5em", height: "2.5em", border: "none" }}
												className="btn btn-sm"
												onMouseDown={(e) => {
													e.preventDefault();
													this.promptForLink();
												}}
											>
												{this.linkIcon()}
											</button>
											<textAlignmentPlugin.TextAlignment {...externalProps} />
										</div>
									)}
								</InlineToolbar>
							</div>
						)}
						{!this.props.readOnly &&
							this.props.articles &&
							typeof this.state.mentionOpen != "undefined" && (
								<MentionSuggestions
									onSearchChange={this.onSearchChange}
									onOpenChange={this.onOpenChange}
									suggestions={
										!this.state.articlesVisible
											? []
											: this.state.articlesVisible.map((article) => {
													return {
														name: article.title,
														link: "/wiki/" + article.slug,
														avatar: ""
													};
											  })
									}
									open={this.state.mentionOpen}
								/>
							)}
					</div>
					{!this.props.readOnly && (
						<footer>
							<CharCounter editorState={editorState} limit={1000000} /> Characters
							<br />
							<WordCounter editorState={editorState} limit={100000} /> Words
							<br />
							<LineCounter editorState={editorState} limit={10000} /> Lines
						</footer>
					)}
					
				</div>
				{this.state.showAddImagePrompt && (
                    <AddImagesWrapper
                        handleCancel={() => this.setState({ showAddImagePrompt: false })}
						handleImageInsert = {this.handleImageInsert}
                    />
                )}
			</EditorWrapperEl>
		);
	}
}

export default EditorWrapper;
